/**
 * Файл с DI константами
 */
import { InjectionToken } from '@angular/core';
import { IAppServiceLanguages } from '@app/app.interface';
import { AppSettings } from '@app/core/libraries/Settings/app-settings';
import { IMainLang } from '@interfaces/languages/main-lang';
import { InterfaceAccessMatrixUnit } from '@modules/login/interfaces/login.interface';

export const APP_LANGUAGES = new InjectionToken<{ [key: string]: IAppServiceLanguages }>('appLanguages');

export const SKELETON_LOADER_TOKEN = 'skeletonLoaderConfig';

export const APP_MAIN_LANGUAGE = new InjectionToken<IAppServiceLanguages>('appMainLanguage');

export const APP_ACCESS = new InjectionToken<InterfaceAccessMatrixUnit>('appAccess');

export const LANG_DICTIONARY_TOKEN = new InjectionToken<IMainLang>('languageDictionary');

export const SERVER_URL_TOKEN = new InjectionToken<string>('serverURL');

export const APP_SETTINGS_TOKEN = new InjectionToken<AppSettings>('appSettings');
